import { url } from "./server"
export const BASE_URL = `${url}/api/recruiters/`
